// extracted by mini-css-extract-plugin
module.exports = {"summary":"DataSourceSummary_summary__3iFfU","print":"DataSourceSummary_print__Vk-Dp"};